module.exports = __webpack_public_path__ + "static/manuel_-9aa31a4325e7e060e49f569afa8321c5.png";